import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  MotifButton,
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
  MotifChip,
} from "@ey-xd/motif-react";
import { IconoirMoreHoriz } from "@ey-xd/motif-icon";
import { CREATE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { PaymentStatus, StatusMapping } from "../type";
import {
  getPaymentStatus,
  havingEditPermission,
  havingAddPermission,
} from "@/utility/common";
import UpdatePaymentStatus from "./UpdatePaymentStatus";
import BulkChequeImport from "./BulkChequeImport";
import { useSelector } from "react-redux";
const TitleComplement = ({
  selectedPaymentIds,
  clearSelectedPayemntIds,
  refreshAfterPaymentUpdate,
  clearFilter,
  isFilterActive,
  allPaymentSelected,
  filterPayload,
  Payment,
  ImportJob,
  handleExport,
  exportingFile,
  setPaymentSuccessMessage,
}: {
  selectedPaymentIds: any;
  clearSelectedPayemntIds: () => void;
  refreshAfterPaymentUpdate: () => void;
  clearFilter: () => void;
  isFilterActive: boolean;
  allPaymentSelected: boolean;
  filterPayload: any;
  Payment: string[];
  ImportJob: string[];
  handleExport: () => void;
  exportingFile: boolean;
  setPaymentSuccessMessage: any;
}) => {
  const { t } = useTranslation();
  const { caseId } = useParams<{ caseId: string }>();

  const navigate = useNavigate();
  const [showUpdateStatuModal, setShowUpdateStatuModal] = useState(false);
  const [showBulkChequeModal, setShowBulkChequeModal] = useState(false);
  // const [showBankActivityModal, setShowBankActivityModal] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [availableStatuses, setAvailableStatuses] = useState<PaymentStatus[]>(
    []
  );

  const permission = useSelector((state: any) => state.permissions);
  const { ChequeUpdate } = permission;
  const isSpecialAccess = ChequeUpdate && ChequeUpdate.includes("Execute");
  const statusTitleMenu = [
    // "Export",
    // "Import Bank Activity",
    // "Payment Documents",
    { label: "global.globalActions.export", value: "export" },
  ];
  if (havingEditPermission(ImportJob)) {
    statusTitleMenu.push({
      label: "pages.paymentStatus.moreOptionsLables.uploadCheck",
      value: "uploadCheck",
    });
    // statusTitleMenu.push({
    //   label: "pages.paymentStatus.moreOptionsLables.uploadBankActivities",
    //   value: "uploadBankActivities",
    // });
  }
  const statusMapping: StatusMapping = {
    Draft: ["Issued", "Void"],
    Issued: ["Cashed", "Undelivered", "Void", "Stop"],
    Cashed: [],
    Undelivered: ["Issued", "Void"],
    Void: ["Replaced"],
    Stop: ["Issued", "Void"],
    Replaced: [],
  };

  const handleMenuClick = (value: string) => {
    if (value === "uploadCheck") {
      setShowBulkChequeModal(true);
      return;
    }
    // if (value === "uploadBankActivities") {
    //   setShowBankActivityModal(true);
    //   return;
    // }
    if (value === "export") {
      handleExport();
    }
  };

  const validateSelectedPayments = (selectedpayments: any[]) => {
    const { paymentStatus } = selectedpayments[0];
    for (let i = 1; i < selectedpayments.length; i++) {
      if (
        getPaymentStatus(selectedpayments[i].paymentStatus) !==
        getPaymentStatus(paymentStatus)
      ) {
        return false;
      }
    }
    return true;
  };

  const handleUpdateStatusPopup = () => {
    if (!validateSelectedPayments(selectedPaymentIds)) {
      setValidationError(t("pages.paymentStatus.sameStatusValidationMessage"));
    } else if (!isSpecialAccess) {
      const paymentStatus = getPaymentStatus(
        selectedPaymentIds[0].paymentStatus
      );
      const availableStatuses =
        statusMapping[paymentStatus as PaymentStatus] || [];
      if (availableStatuses.length === 0) {
        setValidationError(
          t("pages.paymentStatus.emptyStatusValidationMessage", {
            paymentStatus: paymentStatus,
          })
        );
      } else {
        setValidationError("");
        setAvailableStatuses(availableStatuses);
      }
    }
    setShowUpdateStatuModal(true);
  };
  return (
    <>
      <div className="status-title-header">
        {isFilterActive && (
          <MotifChip
            className="clear-search-chip"
            onClick={clearFilter}
            variant="monochrome-dark"
          >
            {t("pages.paymentStatus.clearFilter")}
          </MotifChip>
        )}
        {havingEditPermission(Payment) && (
          <MotifButton
            onClick={handleUpdateStatusPopup}
            size="small"
            type="submit"
            variant="secondary"
            disabled={!selectedPaymentIds.length}
          >
            {t("pages.paymentStatus.updateStatusButton")}
          </MotifButton>
        )}
        {havingAddPermission(Payment) && (
          <MotifButton
            type="button"
            variant={CREATE_BUTTON_VARIANT}
            style={{ height: "36px" }}
            onClick={() => navigate(`/case/${caseId}/payment/payment-setup`)}
          >
            {t("pages.paymentStatus.newPaymentButton")}
          </MotifButton>
        )}
        {statusTitleMenu.length > 0 && (
          <MotifDropdown
            ariaLabelledby="dropdown-trigger-1"
            id="dropdown-1"
            trigger={
              <MotifButton
                aria-label="dropdpwn"
                id="dropdown-trigger-1"
                onClick={function Ga() {}}
                type="button"
                variant="text"
                loading={exportingFile}
              >
                <MotifIcon iconFunction={IconoirMoreHoriz} />
              </MotifButton>
            }
          >
            <ul role="menu">
              {statusTitleMenu.map((menuName, index) => {
                return (
                  <li role="menuitem" key={index}>
                    <MotifDropdownItem
                      indexItem={1}
                      onClick={() => handleMenuClick(menuName.value)}
                    >
                      {t(menuName.label)}
                    </MotifDropdownItem>
                  </li>
                );
              })}
            </ul>
          </MotifDropdown>
        )}
      </div>
      {showUpdateStatuModal && (
        <UpdatePaymentStatus
          showModal={true}
          validationError={validationError}
          currentStatusLabel={getPaymentStatus(
            selectedPaymentIds[0].paymentStatus
          )}
          setShowUpdateStatuModal={setShowUpdateStatuModal}
          selectedPaymentIds={selectedPaymentIds}
          clearSelectedPayemntIds={clearSelectedPayemntIds}
          availableStatuses={availableStatuses}
          refreshAfterPaymentUpdate={refreshAfterPaymentUpdate}
          allPaymentSelected={allPaymentSelected}
          isFilterActive={isFilterActive}
          filterPayload={filterPayload}
		  setPaymentSuccessMessage={setPaymentSuccessMessage}
        />
      )}
      {showBulkChequeModal && (
        <BulkChequeImport
          showModal={true}
          setShowModal={setShowBulkChequeModal}
          title={t("pages.paymentStatus.bulkChequeImport.title")}
          uploadLabel={t("pages.claims.claimsTable.bulkImport.uploadLabel")}
          uploadDescription={t(
            "pages.paymentStatus.bulkChequeImport.uploadDescription"
          )}
          maxFiles={1}
          onClose={() => {
            setShowBulkChequeModal(false);
            setPaymentSuccessMessage({
              show: false,
              message: "",
              type: "",
            });
          }}
        />
      )}
      {/* {showBankActivityModal && (
        <BankActivitiesUploader
          showModal={true}
          setShowModal={setShowBankActivityModal}
          title={t("pages.paymentStatus.bankActivitiesImport.title")}
          uploadLabel={t("pages.claims.claimsTable.bulkImport.uploadLabel")}
          uploadDescription={t(
            "pages.paymentStatus.bankActivitiesImport.uploadDescription"
          )}
          onSucessRefreshApi={clearFilter}
          maxFiles={1}
          onClose={() => {
            setShowBankActivityModal(false);
            setPaymentSuccessMessage({
              show: false,
              message: "",
              type: "",
            });
          }}
        />
      )} */}
    </>
  );
};
export default TitleComplement;
